import { Table, Button, Modal, Form, DatePicker, Input, Card } from 'antd';
import { Link } from 'react-router-dom';
import { FullscreenOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import RowSpan from '../../../ui/RowSpan';
import Page from '../../../ui/Page';
import moment from 'moment';
import { Tabs } from 'antd';
import { useRef } from 'react';

const { TabPane } = Tabs;

const AnalyticsPage = () => {


    const iframeRef1 = useRef<HTMLIFrameElement>(null);
    const iframeRef2 = useRef<HTMLIFrameElement>(null);

    const handleFullscreen = (ref: React.RefObject<HTMLIFrameElement>) => {
        const iframe = ref.current;
        if (iframe) {
            const requestFullscreen =
                iframe.requestFullscreen ||
                (iframe as any).webkitRequestFullscreen ||
                (iframe as any).msRequestFullscreen;

            if (requestFullscreen) {
                requestFullscreen.call(iframe);
            } else {
                console.warn('Fullscreen API is not supported in this browser.');
            }
        }
    };
    return (
        <Page title='Analytics'>
            <Tabs defaultActiveKey="1" type="card">
                <TabPane tab="Аналитика по оценкам" key="1">
                    <div style={{ position: 'relative' }}>
                        <Button
                            icon={<FullscreenOutlined />}
                            style={{ position: 'absolute', top: 10, right: 10, zIndex: 1 }}
                            onClick={() => handleFullscreen(iframeRef1)}
                        >
                            Full screen
                        </Button>
                        <iframe
                            ref={iframeRef1}
                            title="Аналитика по оценкам"
                            src="http://10.1.30.22:8088/superset/dashboard/p/VWQXMPwDNj4/?standalone=1"
                            width="100%"
                            height="800px"
                            style={{ border: 'none' }}
                            allowFullScreen
                        />
                    </div>
                </TabPane>
                <TabPane tab="Контингент студентов" key="2">
                    <div style={{ position: 'relative' }}>
                        <Button
                            icon={<FullscreenOutlined />}
                            style={{ position: 'absolute', top: 10, right: 10, zIndex: 1 }}
                            onClick={() => handleFullscreen(iframeRef2)}
                        >
                            Full screen
                        </Button>
                        <iframe
                            ref={iframeRef2}
                            title="Контингент студентов"
                            src="http://10.1.30.22:8088/superset/dashboard/p/6kGLpoWKVvb/?standalone=1"
                            width="100%"
                            height="800px"
                            style={{ border: 'none' }}
                            allowFullScreen
                        />
                    </div>
                </TabPane>
            </Tabs>

        </Page >
    )
}

export default AnalyticsPage;

